<template>
    <div
        id="message-box"
        class="modal message-box"
        :class="[messageData.context, isOpen ? 'is-active' : '']"
    >
        <div class="modal-background" @click="hideModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title" v-html="messageData.messageTitle"></p>
                <button class="delete" aria-label="close" @click="hideModal"></button>
            </header>
            <section class="modal-card-body" v-html="messageData.messageText"></section>
            <footer class="modal-card-foot">
                <button class="button is-info" @click="getAgreement" v-show="messageData.okText">
                    {{ messageData.okText }}
                </button>
                <button class="button" @click="hideModal" v-show="messageData.cancelText">
                    {{ messageData.cancelText }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { closeModalByEsc } from '../mixins/closeModalByEsc.js';

export default {
    mixins: [closeModalByEsc],
    methods: {
        getAgreement() {
            if (typeof this.messageData.okCallback === 'function') {
                this.messageData.okCallback(this.messageData.okCallbackParamObject);
            }
            this.closeMessageBox();
        },
        hideModal() {
            if (typeof this.messageData.cancelCallback === 'function') {
                this.messageData.cancelCallback(this.messageData.cancelCallbackParamObject);
            }
            this.closeMessageBox();
        },
        ...mapActions('messageBox', ['closeMessageBox']),
    },
    computed: {
        ...mapState('messageBox', ['isOpen', 'messageData']),
    },
}
</script>
